import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').component('imIssueFormAdditionalPersonalData', {
        template:
            require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/issues/issue_forms/fragments/additional_personal_data/additional_personal_data.html'),
        controller: 'IssueFormAdditionalPersonalDataController',
        controllerAs: 'IssueFormAdditionalPersonalDataCtrl',
        bindings: {
            isFullWidth: '<', // boolean
            additionalPersonalData: '=',
        },
    });
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/issue_forms/fragments/additional_personal_data/issue_form_description.component.ts